/**
 * Owner: Masa Bayu
 * File: qxcircle-post-presenter.ts
 * Date:Time: 2026-09-18 11:11
 * Description: QXCircle post presentation — canManage only via owner account id.
 */

import type { QxCircleComment, QxCircleFeedPost } from './qxcircle.types';

export function isManagedQxCirclePost(
  post: QxCircleFeedPost,
  accountId?: string | null,
): boolean {
  if (!accountId || !post.ownerAccountId) {
    return false;
  }
  return post.ownerAccountId === accountId;
}

export function presentQxCirclePost(
  post: QxCircleFeedPost,
  comments: QxCircleComment[],
  localLikes: Set<string>,
  localBookmarks: Set<string>,
  localFollows: Set<string>,
  localMutes: Set<string>,
  accountId?: string | null,
): QxCircleFeedPost {
  return {
    ...post,
    commentCount: comments.filter((c) => c.postId === post.id).length,
    likedByLocal: localLikes.has(post.id),
    savedByLocal: localBookmarks.has(post.id),
    followedByLocal: localFollows.has(post.authorHandle),
    mutedByLocal: localMutes.has(post.authorHandle),
    canManage: isManagedQxCirclePost(post, accountId),
    media: post.media ?? null,
    updatedAt: post.updatedAt ?? null,
  };
}
